import { z } from "zod/v4";
import { absentable, staffRoleSchema } from "./catalog";
import { instantSchema, organizerIdSchema, userIdSchema } from "./ids";
import { organizerSlugProblem } from "./slug";

export const organizerStatusSchema = z.enum(["draft", "live", "suspended"]);
export type OrganizerStatus = z.infer<typeof organizerStatusSchema>;

export const organizerSchema = z.object({
	contactEmail: absentable(z.string()),
	createdAt: instantSchema,
	description: absentable(z.string()),
	id: organizerIdSchema,
	logoUrl: absentable(z.string()),
	name: z.string(),
	slug: z.string(),
	status: organizerStatusSchema,
	updatedAt: instantSchema,
	websiteUrl: absentable(z.string()),
});
export type Organizer = z.infer<typeof organizerSchema>;

/** One entry of `GET /organizers`: the organizer and the caller's role on it. */
export const membershipSchema = z.object({ organizer: organizerSchema, role: staffRoleSchema });
export type Membership = z.infer<typeof membershipSchema>;

export const memberSchema = z.object({
	createdAt: instantSchema,
	email: z.string(),
	role: staffRoleSchema,
	userId: userIdSchema,
});
export type Member = z.infer<typeof memberSchema>;

export const createOrganizerSchema = z.object({
	name: z.string().trim().min(1).max(120),
	slug: z.string().refine((slug) => organizerSlugProblem(slug) === null),
});
export type CreateOrganizer = z.infer<typeof createOrganizerSchema>;

export const organizerProfileSchema = z.object({
	contactEmail: z.string().trim().pipe(z.email()),
	description: z.string().trim().max(2000).optional(),
	logoUrl: z.url().optional(),
	name: z.string().trim().min(1).max(120),
	websiteUrl: z.url().optional(),
});
export type OrganizerProfile = z.infer<typeof organizerProfileSchema>;

export const addMemberSchema = z.object({
	email: z.string().trim().pipe(z.email()),
	role: staffRoleSchema,
});
export type AddMember = z.infer<typeof addMemberSchema>;
